module.exports = __webpack_public_path__ + "static/media/emissor-r-1.07ee5634.png";